<template>
  <div class="content-page" v-if="mechanismList.length">
    <div class="bd">
      <div class="tab-header">
        <div class="header-left">
          <el-button type="primary" size="small" @click="exportExcelOrder"
            >导出列表</el-button
          >
        </div>
        <div class="header-right">
          <div>
            <span>缴费机构：</span>
            <el-select
              v-model="lifePayInstitutionId"
              size="small"
              placeholder="请选择缴费机构"
            >
              <el-option
                v-for="item in mechanismList"
                :key="item.lifePayInstitutionId"
                :label="item.institutionName"
                :value="item.lifePayInstitutionId"
              >
              </el-option>
            </el-select>
          </div>
          <div>
            <span>缴费项目：</span>
            <el-select
              v-model="lifePayBatchId"
              size="small"
              placeholder="请选择缴费项目"
            >
              <el-option
                v-for="item in projectList"
                :key="item.lifePayBatchId"
                :label="item.lifePayBatchName"
                :value="item.lifePayBatchId"
              >
              </el-option>
            </el-select>
          </div>
          <el-input
            :placeholder="
              `请输入${
                lifePayInstitutionId
                  ? mechanismObj[lifePayInstitutionId].accountNoName
                  : '身份证号'
              }`
            "
            v-model.trim="lifePayAccountNo"
            class="input-search"
            size="small"
          >
          </el-input>
          <el-radio-group size="small" v-model="orderStatus">
            <el-radio-button :label="-1">全部</el-radio-button>
            <el-radio-button :label="40">已缴费</el-radio-button>
            <el-radio-button :label="10">未缴费</el-radio-button>
          </el-radio-group>
          <el-button size="small" type="primary" @click="searchBill"
            >查询</el-button
          >
        </div>
      </div>
      <div class="tab-content">
        <div class="list">
          <el-table :data="lifePayOrderList" style="width: 100%;">
            <el-table-column
              :label="
                `${
                  lifePayInstitutionId
                    ? mechanismObj[lifePayInstitutionId].accountName
                    : '姓名'
                }`
              "
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div class="name">{{ scope.row.lifePayAccountName }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="
                `${
                  lifePayInstitutionId
                    ? mechanismObj[lifePayInstitutionId].accountNoName
                    : '身份证号'
                }`
              "
              header-align="center"
              align="center"
              width="200px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.lifePayAccountNo }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="
                `${
                  lifePayInstitutionId
                    ? mechanismObj[lifePayInstitutionId].accountInfoName01
                    : '年级'
                }`
              "
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.accountInfo01 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="
                `${
                  lifePayInstitutionId
                    ? mechanismObj[lifePayInstitutionId].accountInfoName02
                    : '班级'
                }`
              "
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.accountInfo02 }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="应缴金额"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-popover placement="top" width="200" trigger="hover">
                  <div class="popover">
                    <div class="title">
                      {{ scope.row.lifePayAccountName }}的缴费信息
                    </div>
                    <div class="content">
                      <div
                        v-for="item in scope.row.products"
                        :key="item.mallOrderProductId"
                      >
                        {{ item.goodsName }}：{{ item.totalRetailPrice }}
                      </div>
                    </div>
                  </div>
                  <div class="template-name" slot="reference">
                    {{ scope.row.orderMoney }}
                  </div>
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column
              label="服务费率 / 服务费 （缴费人承担）"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.orderFeeRate }}%/{{ scope.row.orderFeeMoney }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="交易号"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.outTradeNo }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="交易状态"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.orderStatus == 40 ? "已缴费" : "未缴费" }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="支付方式"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <div>
                  {{ payInterfacePartyType[scope.row.payInterfacePartyType] }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="lifePayBatchObj[lifePayBatchId].customInfoName01"
              header-align="center"
              align="center"
              v-if="
                lifePayBatchId &&
                  lifePayBatchObj[lifePayBatchId].customInfoName01
              "
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.accountCustomInfo01 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="lifePayBatchObj[lifePayBatchId].customInfoName02"
              header-align="center"
              align="center"
              v-if="
                lifePayBatchId &&
                  lifePayBatchObj[lifePayBatchId].customInfoName02
              "
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.accountCustomInfo02 }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="备注" header-align="center" align="center">
              <template slot-scope="scope">
                <div @click="edit(scope.$index, 'remark')">
                  <div class="remark" v-if="scope.row.orderMark">
                    {{ scope.row.orderMark }}
                  </div>
                  <el-button v-else size="small" type="primary" plain
                    >备注</el-button
                  >
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              header-align="center"
              align="center"
              width="200"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.orderStatus != 40">
                  <el-button
                    size="small"
                    type="primary"
                    @click="edit(scope.$index, 'book')"
                    plain
                    >记账</el-button
                  >
                  <el-button
                    size="small"
                    type="primary"
                    @click="deleteBill(scope.row)"
                    plain
                    >删除</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="dialogClose"
      width="510px"
    >
      <div slot="title" class="dialog-title">
        {{ dialogType == "remark" ? "备注" : "记账" }}
      </div>
      <el-form label-width="68px" class="demo-ruleForm">
        <el-form-item
          label="记账方式"
          prop="fullName"
          v-if="dialogType == 'book'"
        >
          <el-radio v-model="orderBookkeeping" :label="8" border>刷卡</el-radio>
          <el-radio v-model="orderBookkeeping" :label="9" border>现金</el-radio>
        </el-form-item>
        <el-form-item label="备注">
          <el-input
            type="textarea"
            v-model="remark"
            placeholder="请填写备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm" :loading="isSubmit"
          >确定</el-button
        >
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import cityJson from "@/assets/js/cityData.json";
import {
  exportExcelOrder,
  getLifePayInstitutionList,
  getLifePayBatchList,
  getLifePayOrderList,
  getLifePayOrderListCount,
  setOrderMark,
  setOrderBookkeeping,
  delOrder,
} from "@/api/index.js";
import request from "@/utils/request";
export default {
  data() {
    return {
      orderStatus: -1,
      lifePayInstitutionId: "",
      mechanismList: [],
      mechanismObj: null,
      lifePayBatchId: "",
      lifePayBatchObj: null,
      projectList: [],
      lifePayAccountNo: "",
      payInterfacePartyType: {
        8: "刷卡记账",
        9: "现金记账",
        2: "支付宝",
        3: "微信",
      },
      pageSize: 5,
      pageCount: 0,
      pageNo: 1,
      lifePayOrderList: [],
      dialogVisible: false,
      dialogType: "",
      orderBookkeeping: 0,
      remark: "",
      mallOrderId: "",
      isSubmit: false,
      isUpload: false,
    };
  },
  watch: {
    lifePayInstitutionId(val) {
      this.lifePayBatchId = "";
      if (val) {
        this.getLifePayBatchList();
      }
    },
  },
  mounted() {
    console.log(this.$route);
    if (this.$route.params.lifePayBatchId) {
      this.lifePayInstitutionId = this.$route.params.lifePayInstitutionId;
    }
    this.getLifePayInstitutionList();
  },
  methods: {
    getPageData() {
      this.pageNo = 1;
      this.getLifePayOrderList();
      this.getLifePayOrderListCount();
    },
    getLifePayOrderList() {
      getLifePayOrderList({
        pageNo: this.pageNo,
        row: this.pageSize,
        lifePayInstitutionId: this.lifePayInstitutionId,
        lifePayBatchId: this.lifePayBatchId,
        lifePayAccountNo: this.lifePayAccountNo,
        orderStatus: this.orderStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.lifePayOrderList = res.data;
        } else {
          this.lifePayOrderList = [];
          this.$notify({
            title: "警告",
            message: "没有数据",
            type: "warning",
          });
        }
      });
    },
    getLifePayOrderListCount() {
      getLifePayOrderListCount({
        pageNo: this.pageNo,
        row: this.pageSize,
        lifePayInstitutionId: this.lifePayInstitutionId,
        lifePayBatchId: this.lifePayBatchId,
        lifePayAccountNo: this.lifePayAccountNo,
        orderStatus: this.orderStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    getLifePayInstitutionList() {
      getLifePayInstitutionList({
        pageNo: 1,
        row: 99999,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            if (!this.mechanismObj) {
              this.mechanismObj = {};
            }
            this.mechanismObj[val.lifePayInstitutionId] = val;
          });
          this.mechanismList = res.data;
        }
        if (res.code == -1) {
          this.mechanismList = [];
        }
      });
    },
    getLifePayBatchList() {
      getLifePayBatchList({
        pageNo: 1,
        row: 99999,
        lifePayInstitutionId: this.lifePayInstitutionId,
      }).then((res) => {
        if (res.code == 1) {
          res.data.forEach((val) => {
            if (!this.lifePayBatchObj) {
              this.lifePayBatchObj = {};
            }
            this.lifePayBatchObj[val.lifePayBatchId] = val;
          });
          this.projectList = res.data;
          if (this.$route.params.lifePayBatchId) {
            this.lifePayBatchId = this.$route.params.lifePayBatchId;
            delete this.$route.params.lifePayBatchId;
            this.searchBill();
            return;
          }
          this.lifePayBatchId = this.projectList[0].lifePayBatchId;
          this.searchBill();
        }
        if (res.code == -1) {
          this.projectList = [];
          this.lifePayOrderList = [];
        }
      });
    },
    getShopMemberListNum() {
      getShopMemberListNum({
        code: String(this.searchInput),
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
        if (res.code == -1) {
          this.pageCount = 0;
        }
      });
    },
    searchBill() {
      if (!this.lifePayInstitutionId) {
        this.$notify({
          title: "警告",
          message: "请选择缴费机构",
          type: "warning",
        });
        return;
      }
      if (!this.lifePayBatchId) {
        this.$notify({
          title: "警告",
          message: "请选择缴费项目",
          type: "warning",
        });
        return;
      }
      this.getPageData();
    },
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getShopMemberList();
    },
    deleteBill(row) {
      this.$confirm("您确定要删除该账单吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delOrder({
            mallOrderId: row.mallOrderId,
          }).then((res) => {
            if (res.code == 1) {
              this.getPageData();
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "success",
                duration: 1000,
              });
            } else {
              this.$notify({
                title: "提示",
                message: res.msg,
                type: "error",
                duration: 1000,
              });
            }
          });
        })
        .catch(() => {});
    },
    edit(index, type) {
      this.mallOrderId = this.lifePayOrderList[index].mallOrderId;
      this.remark = this.lifePayOrderList[index].orderMark;
      this.dialogType = type;
      this.showDialog();
    },
    dialogClose() {},
    vipCardDialogClose() {
      this.isUpload = false;
    },
    showDialog() {
      this.dialogVisible = true;
    },
    confirm() {
      if (this.dialogType == "book" && !this.orderBookkeeping) {
        this.$notify({
          title: "提示",
          message: "请选择记账方式",
          type: "warning",
          duration: 2000,
        });
        return;
      }
      this.isSubmit = true;
      if (this.dialogType == "remark") {
        setOrderMark({
          mallOrderId: this.mallOrderId,
          orderMark: this.remark,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
            this.dialogVisible = false;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
          setTimeout(() => {
            this.isSubmit = false;
          }, 500);
        });
      } else {
        setOrderBookkeeping({
          mallOrderId: this.mallOrderId,
          payInterfacePartyType: this.orderBookkeeping,
          orderMark: this.remark,
        }).then((res) => {
          if (res.code == 1) {
            this.$notify({
              title: "提示",
              message: "操作成功",
              type: "success",
              duration: 2000,
            });
            this.getPageData();
            this.dialogVisible = false;
          } else {
            this.$notify({
              title: "提示",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
          setTimeout(() => {
            this.isSubmit = false;
          }, 500);
        });
      }
    },
    exportExcelOrder() {
      location.href = exportExcelOrder({
        lifePayInstitutionId: this.lifePayInstitutionId,
        lifePayBatchId: this.lifePayBatchId,
        lifePayAccountNo: this.lifePayAccountNo,
        orderStatus: this.orderStatus,
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .header-right {
    .el-select {
      width: 180px;
    }
    & > div {
      margin-left: 10px;
    }
    .el-button {
      margin-left: 10px;
    }
  }
  .template-name {
    color: #66b1ff;
    cursor: pointer;
  }
  .upload-xls {
    margin: 0 10px;
  }
  .list {
    width: 100%;
    padding: 0 20px;
  }
  .el-cascader {
    width: 100%;
  }
}
.popover {
  .title {
    line-height: 30px;
  }
  .content {
    color: #66b1ff;
  }
}
.remark {
  color: #66b1ff;
  cursor: pointer;
}
</style>

<style lang="less">
.upload-xls-btn {
  display: inline-block;
  margin: 0 10px;
}
</style>